/* ==========================================================================
   GLAM — interacciones propias. Todo vanilla, sin librerias externas.
   Cada init comprueba si su elemento existe, asi el archivo sirve en
   cualquier pagina del tema.
   ========================================================================== */

(function () {
  'use strict';

  var REDUCIDO = window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------------------------------------------------------- reveals */
  function initReveals() {
    var elementos = document.querySelectorAll('.mt-reveal, .mt-cortina, .mt-linea-mask');
    if (!elementos.length) return;

    if (REDUCIDO || !('IntersectionObserver' in window)) {
      elementos.forEach(function (el) { el.classList.add('mt-visible'); });
      return;
    }

    var obs = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('mt-visible');
        obs.unobserve(e.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

    elementos.forEach(function (el) { obs.observe(el); });
  }

  /* -------------------------------------------------------------- parallax */
  function initParallax() {
    var capas = document.querySelectorAll('[data-mt-parallax]');
    if (!capas.length || REDUCIDO) return;

    var pendiente = false;

    function pintar() {
      pendiente = false;
      var vh = window.innerHeight;
      capas.forEach(function (capa) {
        var caja = capa.parentElement.getBoundingClientRect();
        if (caja.bottom < -200 || caja.top > vh + 200) return;
        var fuerza = parseFloat(capa.getAttribute('data-mt-parallax')) || 12;
        // -1 (debajo de la pantalla) .. 1 (encima)
        var progreso = (caja.top + caja.height / 2 - vh / 2) / (vh / 2 + caja.height / 2);
        capa.style.transform = 'translate3d(0,' + (progreso * fuerza).toFixed(2) + '%,0)';
      });
    }

    function alScroll() {
      if (pendiente) return;
      pendiente = true;
      window.requestAnimationFrame(pintar);
    }

    window.addEventListener('scroll', alScroll, { passive: true });
    window.addEventListener('resize', alScroll, { passive: true });
    pintar();
  }

  /* ---------------------------------------------------------------- ritual */
  function initRitual() {
    document.querySelectorAll('[data-mt-ritual]').forEach(function (raiz) {
      var pasos = raiz.querySelectorAll('.mt-rit__paso');
      var capas = raiz.querySelectorAll('.mt-rit__capa');
      var contador = raiz.querySelector('[data-mt-rit-actual]');
      if (!pasos.length) return;

      function activar(i) {
        pasos.forEach(function (p, n) { p.classList.toggle('is-activo', n === i); });
        capas.forEach(function (c, n) { c.classList.toggle('is-activa', n === i); });
        if (contador) contador.textContent = ('0' + (i + 1)).slice(-2);
      }

      activar(0);

      if (!('IntersectionObserver' in window)) {
        pasos.forEach(function (p) { p.classList.add('is-activo'); });
        capas.forEach(function (c) { c.classList.add('is-activa'); });
        return;
      }

      var obs = new IntersectionObserver(function (entradas) {
        entradas.forEach(function (e) {
          if (!e.isIntersecting) return;
          var i = Array.prototype.indexOf.call(pasos, e.target);
          if (i > -1) activar(i);
        });
      }, { rootMargin: '-45% 0px -45% 0px', threshold: 0 });

      pasos.forEach(function (p) { obs.observe(p); });
    });
  }

  /* ------------------------------------------------------------ comparador */
  function initComparador() {
    document.querySelectorAll('[data-mt-comparador]').forEach(function (marco) {
      var asa = marco.querySelector('.mt-cmp__asa');
      if (!asa) return;

      var arrastrando = false;

      function fijar(pct) {
        var v = Math.max(0, Math.min(100, pct));
        marco.style.setProperty('--mt-pos', v + '%');
        asa.setAttribute('aria-valuenow', Math.round(v));
      }

      function desdeEvento(ev) {
        var caja = marco.getBoundingClientRect();
        var x = (ev.touches && ev.touches[0] ? ev.touches[0].clientX : ev.clientX);
        fijar(((x - caja.left) / caja.width) * 100);
      }

      function empezar(ev) {
        arrastrando = true;
        desdeEvento(ev);
      }
      function mover(ev) {
        if (!arrastrando) return;
        if (ev.cancelable && ev.touches) ev.preventDefault();
        desdeEvento(ev);
      }
      function parar() { arrastrando = false; }

      marco.addEventListener('mousedown', empezar);
      window.addEventListener('mousemove', mover);
      window.addEventListener('mouseup', parar);

      marco.addEventListener('touchstart', empezar, { passive: true });
      window.addEventListener('touchmove', mover, { passive: false });
      window.addEventListener('touchend', parar);

      asa.addEventListener('keydown', function (ev) {
        var actual = parseFloat(asa.getAttribute('aria-valuenow')) || 50;
        if (ev.key === 'ArrowLeft') { fijar(actual - 4); ev.preventDefault(); }
        if (ev.key === 'ArrowRight') { fijar(actual + 4); ev.preventDefault(); }
      });

      fijar(50);
    });
  }

  /* ---------------------------------------------------------------- cifras */
  function initCifras() {
    var cifras = document.querySelectorAll('[data-mt-cifra]');
    if (!cifras.length) return;

    if (REDUCIDO || !('IntersectionObserver' in window)) {
      cifras.forEach(function (el) { el.textContent = el.getAttribute('data-mt-cifra'); });
      return;
    }

    var obs = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        obs.unobserve(el);
        var destino = parseFloat(el.getAttribute('data-mt-cifra')) || 0;
        var decimales = (String(destino).split('.')[1] || '').length;
        var inicio = null;
        var dur = 1500;

        function paso(t) {
          if (inicio === null) inicio = t;
          var p = Math.min((t - inicio) / dur, 1);
          var suave = 1 - Math.pow(1 - p, 3);
          el.textContent = (destino * suave).toFixed(decimales);
          if (p < 1) window.requestAnimationFrame(paso);
        }
        window.requestAnimationFrame(paso);
      });
    }, { threshold: 0.5 });

    cifras.forEach(function (el) { obs.observe(el); });
  }

  /* ------------------------------------------------------------------- faq */
  function initFaq() {
    document.querySelectorAll('[data-mt-faq]').forEach(function (raiz) {
      var items = raiz.querySelectorAll('.mt-faq__item');
      items.forEach(function (item) {
        var btn = item.querySelector('.mt-faq__btn');
        if (!btn) return;
        btn.addEventListener('click', function () {
          var abierto = item.classList.contains('is-abierto');
          items.forEach(function (o) {
            o.classList.remove('is-abierto');
            var b = o.querySelector('.mt-faq__btn');
            if (b) b.setAttribute('aria-expanded', 'false');
          });
          if (!abierto) {
            item.classList.add('is-abierto');
            btn.setAttribute('aria-expanded', 'true');
          }
        });
      });
    });
  }

  /* -------------------------------------------------------------- producto */
  function initProducto() {
    var raiz = document.querySelector('[data-mt-producto]');
    if (!raiz) return;

    /* --- galeria --- */
    var principal = raiz.querySelector('[data-mt-pr-principal]');
    var minis = raiz.querySelectorAll('[data-mt-pr-mini]');

    minis.forEach(function (mini) {
      mini.addEventListener('click', function () {
        var src = mini.getAttribute('data-src');
        if (!src || !principal) return;
        principal.style.opacity = '0';
        window.setTimeout(function () {
          principal.src = src;
          var alt = mini.getAttribute('data-alt');
          if (alt !== null) principal.alt = alt;
          principal.style.opacity = '1';
        }, 180);
        minis.forEach(function (m) { m.classList.remove('is-activa'); });
        mini.classList.add('is-activa');
      });
    });

    /* --- variantes --- */
    var datos = raiz.querySelector('[data-mt-pr-variantes]');
    if (!datos) return;

    var variantes;
    try { variantes = JSON.parse(datos.textContent); }
    catch (err) { return; }
    if (!variantes || !variantes.length) return;

    var inputId   = raiz.querySelector('[data-mt-pr-id]');
    var elPrecio  = raiz.querySelector('[data-mt-pr-precio]');
    var elAntes   = raiz.querySelector('[data-mt-pr-antes]');
    var elAhorro  = raiz.querySelector('[data-mt-pr-ahorro]');
    var boton     = raiz.querySelector('[data-mt-pr-boton]');
    var elStock   = raiz.querySelector('[data-mt-pr-stock]');
    var puntoStock= raiz.querySelector('[data-mt-pr-punto]');
    var txtCompra = raiz.getAttribute('data-txt-comprar') || 'Anadir al carrito';
    var txtAgotado= raiz.getAttribute('data-txt-agotado') || 'Agotado';
    var txtDisp   = raiz.getAttribute('data-txt-disponible') || 'En stock';
    var txtNoDisp = raiz.getAttribute('data-txt-nodisponible') || 'Sin stock';

    var seleccion = [];
    raiz.querySelectorAll('[data-mt-pr-opcion]').forEach(function (grupo, i) {
      var activo = grupo.querySelector('.mt-pr__valor.is-activo');
      seleccion[i] = activo ? activo.getAttribute('data-valor') : null;

      grupo.querySelectorAll('.mt-pr__valor').forEach(function (btn) {
        btn.addEventListener('click', function () {
          grupo.querySelectorAll('.mt-pr__valor').forEach(function (b) {
            b.classList.remove('is-activo');
          });
          btn.classList.add('is-activo');
          seleccion[i] = btn.getAttribute('data-valor');
          refrescar();
        });
      });
    });

    // En la primera llamada NO tocamos la foto principal: la galeria ya muestra
    // la primera imagen del producto, y la foto asignada a la variante puede ser
    // una antigua. Solo cambiamos la foto cuando el usuario elige otra variante.
    var primeraVez = true;

    function refrescar() {
      var v = null;
      for (var i = 0; i < variantes.length; i++) {
        var coincide = true;
        for (var j = 0; j < seleccion.length; j++) {
          if (seleccion[j] !== null && variantes[i].options[j] !== seleccion[j]) {
            coincide = false;
            break;
          }
        }
        if (coincide) { v = variantes[i]; break; }
      }

      if (!v) {
        if (boton) { boton.disabled = true; boton.textContent = txtAgotado; }
        return;
      }

      if (inputId) inputId.value = v.id;
      if (elPrecio) elPrecio.textContent = v.precio;

      if (elAntes) {
        if (v.rebajado) {
          elAntes.textContent = v.antes;
          elAntes.hidden = false;
          if (elAhorro) {
            elAhorro.textContent = '-' + v.descuento + '%';
            elAhorro.hidden = false;
          }
        } else {
          elAntes.hidden = true;
          if (elAhorro) elAhorro.hidden = true;
        }
      }

      if (boton) {
        boton.disabled = !v.available;
        boton.textContent = v.available ? txtCompra : txtAgotado;
      }
      if (elStock) elStock.textContent = v.available ? txtDisp : txtNoDisp;
      if (puntoStock) puntoStock.classList.toggle('mt-pr__punto--no', !v.available);

      if (!primeraVez && v.imagen && principal) principal.src = v.imagen;
      primeraVez = false;

      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    refrescar();
  }

  /* ------------------------------------------------------------------ init */
  function arrancar() {
    initReveals();
    initParallax();
    initRitual();
    initComparador();
    initCifras();
    initFaq();
    initProducto();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }

  // El editor de Shopify recarga secciones sueltas: re-inicializa.
  document.addEventListener('shopify:section:load', arrancar);
})();
